import type { HomeLocales } from '@/types/lang/locales'

export const homeEn: HomeLocales = {
    announcementsTitle: 'Announcements',
    newsTitle: 'Latest news',
    welcomeTitle: 'Welcome on the uRTime hub',
    welcomeContent:
        'Welcome on the new uRTime Hub ! Please do not hesitate to contact us with any comments or difficulties you may encounter at the following email address : customercare@urtime.net.'
}
